module.exports = __webpack_public_path__ + "img/__becodrivelogo.6f68f34b.svg";